export enum UnitOfMeasure {
  /** Billion cubic feet */
  BillionCubicFeet = 'Bcf',
  /** Allowances */
  Allowances = 'Alw',
  /** Cubic Meters */
  CubicMeters = 'CBM',
  Barrels = 'Bbl',
  /** gigajoules */
  Gigajoules = 'GJ',
  BoardFeet = 'BDFT',
  HeatRate = 'kHR',
  /** Bushels */
  Bushels = 'Bu',
  /** Kilowatt hours */
  KilowattHours = 'kWh',
  /** Amount of currency */
  Currency = 'Ccy',
  MegaHeatRate = 'MHR',
  /** Cooling degree day */
  CoolingDegreeDay = 'CDD',
  /** One Million BTU */
  OneMillionBTU = 'MMBtu',
  /** Certified emissions reduction */
  CertifiedEmissionsReduction = 'CER',
  /** Megawatt hours */
  MegawattHours = 'MWh',
  /** Critical precipitation day */
  CriticalPrecipDay = 'CPD',
  Therms = 'thm',
  /** Climate reserve tonnes */
  ClimateReserveTonnes = 'CRT',
  /** Tons of carbon dioxide */
  TonsOfCarbonDioxide = 'tnCO2',
  Hundredweight = 'cwt',
  /** Days */
  Day = 'day',
  /** Dry metric tons */
  DryMetricTons = 'dt',
  /** Environmental allowance certificates */
  EnvAllwncCert = 'EnvAllwnc',
  /** Environmental credit */
  EnvironmentalCredit = 'EnvCrd',
  /** Environmental Offset */
  EnvironmentalOffset = 'EnvOfst',
  /** Grams */
  Grams = 'g',
  /** Gallons */
  Gallons = 'Gal',
  GrossTons = 'GT',
  /** Heating degree day */
  HeatingDegreeDay = 'HDD',
  /** Index point */
  IndexPoint = 'IPNT',
  /** Kilograms */
  Kilograms = 'kg',
  /** kiloliters */
  Kiloliters = 'kL',
  /** Kilowatt year (electrical capacity) */
  KilowattYear = 'kW-a',
  /** Kilowatt day (electrical capacity) */
  KilowattDay = 'kW-d',
  /** Kilowatt hour (electrical capacity) */
  KilowattHour = 'kW-h',
  /** Kilowatt month (electrical capacity) */
  KilowattMonth = 'kW-M',
  /** Kilowatt-Minute (electrical capacity) */
  KilowattMinute = 'kW-min',
  /** liters */
  Liters = 'L',
  /** pounds */
  Pounds = 'lbs',
  /** Megawatt year (electrical capacity) */
  MegawattYear = 'MW-a',
  /** Megawatt day (electrical capacity) */
  MegawattDay = 'MW-d',
  /** Megawatt hour (electrical capacity) */
  MegawattHour = 'MW-h',
  /** Megawatt month (electrical capacity) */
  MegawattMonth = 'MW-M',
  /** Megawatt minute (electrical capacity) */
  MegawattMinute = 'MW-min',
  /** Troy ounces */
  TroyOunces = 'oz_tr',
  /** Principal with relation to debt instrument */
  PrincipalWithRelationToDebtInstrument = 'PRINC',
  MetricTons = 't',
  Tons = 'tn',
  /** Are */
  Are = 'a',
  /** Acre */
  Acre = 'ac',
  /** Centiliter */
  Centiliter = 'cL',
  /** Centimeter */
  Centimeter = 'cM',
  /** Diesel gallon equivalent */
  DieselGallonEquivalent = 'DGE',
  /** Foot */
  Foot = 'ft',
  /** GB Gallon */
  GBGallon = 'Gal_gb',
  /** Gasonline gallon equivalent */
  GasolineGallonEquivalent = 'GGE',
  /** Hectare */
  Hectare = 'ha',
  /** Inch */
  Inch = 'in',
  /** Kilometer */
  Kilometer = 'kM',
  /** Meter */
  Meter = 'M',
  /** Mile */
  Mile = 'mi',
  /** Milliliter */
  Milliliter = 'mL',
  /** Millimeter */
  Millimeter = 'mM',
  /** US ounce */
  USOunce = 'oz',
  /** Piece */
  Piece = 'pc',
  /** US Pint */
  USPint = 'pt',
  /** GB pint */
  GBPint = 'pt_gb',
  /** US Quart */
  USQuart = 'qt',
  /** GB Quart */
  GBQuart = 'qt_gb',
  /** Square centimeter */
  SquareCentimeter = 'SqcM',
  /** Square foot */
  SquareFoot = 'Sqft',
  /** Square inch */
  SquareInch = 'Sqin',
  /** Square kilometer */
  SquareKilometer = 'SqkM',
  /** Square meter */
  SquareMeter = 'SqM',
  /** Square mile */
  SquareMile = 'Sqmi',
  /** Square millimeter */
  SquareMillimeter = 'SqmM',
  /** Square yard */
  SquareYard = 'Sqyd',
  /** Yard */
  Yard = 'yd',
  /** Million Barrels */
  MillionBarrels = 'MMbbl',
  /** US Dollars */
  USDollars = 'USD',
}
